/**
 * wspólny skrypt dla wszystkich oparych na tym szablonie serwisów
 * więc ostrożnei z wrzucaniem tu modułów
 */
console.log('LOADED: common');

import './images';
import './systemscan';

import('./cookies').then(() => {}).catch((error) => {
  console.log('Cookies load failed!');
  console.log(error);
});

$('#main .left .mobile-menu').clone().appendTo($('#main .main_top'));

$('body').on('click', '.foot_menu .title, .mobile-menu .title', function(event) {
	if (window.innerWidth < 991) {
		event.preventDefault();
		$(this).parent().toggleClass('open');
	}
});

if(window.location.hash) {
	var anchor = $(window.location.hash);
	if(anchor.length) {
		$(anchor).parent().addClass('open');
	}
}

if($(".copy_string").length) {
	$(".copy_string").click(function () {
		this.select();
	});
}

var downloadBoxLeft = $('.main .left .downloadBox');
var onlineZrzut     = $('.main .left .online-zrzut');
var renderButton    = $('body.body-opp .main .left .render-button');
var renderebook     = $('.main .left .ebookPIT11');


if(downloadBoxLeft.length)$('body .main .center').append(downloadBoxLeft.clone().addClass('visible-xs visible-sm'));
if(onlineZrzut.length) $('body .main .center').append(onlineZrzut.clone().addClass('visible-xs visible-sm'));
if(renderButton.length) $('body .main .center').append(renderButton.clone().addClass('visible-xs visible-sm'));

$('table.tabelka').wrap('<div class="tabelka-wrapper"></div>');

function loadImage(el) {
  var img = new Image(), src = el.data('src');

  img.onload = function() {
    el.attr('src', src);
    el.siblings('.loader').remove();
  };

  img.src = src;
}

$('img[data-src]').each(function(index, img) {
  loadImage($(img));
});

